import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom'; 
import StarButton from '../components/StarButton';

function CreateCoHost() {
  const navigate = useNavigate();

  const { listingId } = useParams();
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [bio, setBio] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [profileImage, setProfileImage] = useState(null);
  const [previewImage, setPreviewImage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [formErrors, setFormErrors] = useState({});

  const successMessageRef = useRef(null);

  useEffect(() => {
    if (successMessage && successMessageRef.current) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [successMessage]);

  const validateForm = () => {
    const errors = {};
    if (!firstName) errors.firstName = true;
    if (!lastName) errors.lastName = true;
    if (!email) errors.email = true;
    if (!number) errors.number = true;
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    switch (name) {
      case 'firstName':
        setFirstName(value);
        if (!value) setFormErrors((prev) => ({ ...prev, firstName: true }));
        else setFormErrors((prev) => ({ ...prev, firstName: false }));
        break;
      case 'middleName':
        setMiddleName(value);
        break;
      case 'lastName':
        setLastName(value);
        if (!value) setFormErrors((prev) => ({ ...prev, lastName: true }));
        else setFormErrors((prev) => ({ ...prev, lastName: false }));
        break;
      case 'email':
        setEmail(value);
        if (!value) setFormErrors((prev) => ({ ...prev, email: true }));
        else setFormErrors((prev) => ({ ...prev, email: false }));
        break;
      case 'number':
        setNumber(value);
        if (!value) setFormErrors((prev) => ({ ...prev, number: true }));
        else setFormErrors((prev) => ({ ...prev, number: false }));
        break;
      case 'bio':
        setBio(value);
        break;
      default:
        break;
    }
  };

  const ProceedRegister = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    setFormErrors(errors);

    const hostData = getItemFromLocalStorage('hostProfile');

    let formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('listing_id', listingId);  
    formData.append('host_name', firstName);
    formData.append('host_midname', middleName);
    formData.append('host_lastname', lastName);
    formData.append('host_contact_number', number);
    formData.append('host_contact_email', email);
    formData.append('host_logo', profileImage);
    formData.append('host_bio', bio);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: `${params.baseURL}${params.endpoints.saveCoHost}`,
        data: formData
      });

      if (response.data.status === 'new') {
        toast.success('Your profile data updated successfully.');
        navigate(`/manage-co-host/${listingId}`);
      } else if (response.data.status === 'error') {
        toast.error(response.data.list);
      } else {
        toast.error('Error in saving data.');
      }
    } catch (err) {
      toast.error('An error occurred while saving data.');
    }
  }

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  }; 

  return (
    <div>
      <Helmet>
          <title>Create Co Host</title>
          <style>{`
          .star-button {
            bottom: 30px;
          }
        `}</style>
      </Helmet>
      <section className="registration-form" style={{ height: '100%', overflow: 'hidden' }}>
      
        <div className='row'>
          <div className='col-md-6 register-left-panel' style={{backgroundImage: 'url(/assets/img/banners/co_host_profile_banner.webp)'}}>
            <StarButton text="Guide" link="#" />
          </div>
          <div className='col-md-6 offset-md-6'>
            <div className="form-body">
              <div className="row">
                <div className="form-holder">
                  <div className="form-content">
                    <div className="form-items">
                      <h4 className='register-title mb-4'>Create Co-Host Profile</h4>
                      <form className="needs-validation" encType="multipart/form-data" onSubmit={ProceedRegister}>

                        <div className='row'>
                          <div className="col-md-12 mb-4">
                            <div className='form-flex'>
                              <div className='pimg form-icon'>
                                <img 
                                  src='/assets/img/icons/profile_image_icon.svg'
                                  className='pimg form-icon img-fluid'
                                  alt=''
                                />
                              </div>
                              <div className="form-txt host-profile-section">
                                <label>
                                  <div>
                                    {previewImage ? (
                                      <img src={previewImage} alt="Preview" className='host-profile-img' />
                                    ) : (
                                      <img src="/assets/img/host_default_image.png" alt="Default"className='host-profile-img' />
                                    )}
                                  </div>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    className="d-none"
                                    onChange={handleProfileImageChange}
                                  />
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 mb-4">
                            <div className='form-flex form-icon-box'>
                              <div className='form-icon'>
                                <img 
                                  src='/assets/img/icons/legal_name_icon.svg'
                                  className='form-icon img-fluid'
                                  alt=''
                                />
                              </div>
                              <div className='form-txt'>
                                <div className="form-floating">
                                  <input className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`} type="text" id="firstName" name="firstName" value={firstName} onChange={handleChange} onKeyUp={handleChange} onKeyDown={(e) => {
                                      if (e.key === " ") e.preventDefault();
                                  }} />
                                  <label htmlFor="firstName">First Name</label>
                                </div>
                              </div>
                            </div> 
                          </div>

                          <div className="col-md-12 mb-4">
                            <div className='form-flex form-icon-box'>
                              <div className='form-icon'>
                                <img 
                                  src='/assets/img/icons/legal_name_icon.svg'
                                  className='form-icon img-fluid'
                                  alt=''
                                />
                              </div>
                              <div className='form-txt'>
                                <div className="form-floating">
                                  <input className={`form-control ${formErrors.middleName ? 'is-invalid' : ''}`} type="text" id="middleName" name="middleName" value={middleName} onChange={handleChange} onKeyUp={handleChange}/>
                                  <label htmlFor="middleName">Middle Name</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 mb-4">
                            <div className='form-flex form-icon-box'>
                              <div className='form-icon'>
                                <img 
                                  src='/assets/img/icons/legal_name_icon.svg'
                                  className='form-icon img-fluid'
                                  alt=''
                                />
                              </div>
                              <div className='form-txt'>
                                <div className="form-floating">
                                  <input className={`form-control ${formErrors.lastName ? 'is-invalid' : ''}`} type="text" id="lastName" name="lastName" value={lastName} onChange={handleChange} onKeyUp={handleChange} />
                                  <label htmlFor="lastName">Last Name</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 mb-4">
                            <div className='form-flex'>
                              <div className='pvline form-icon'></div>
                              <div className='form-txt'>
                                <div className="form-floating">
                                  <textarea className='form-control' type="text" id="bio" name="bio" cols={4} rows={5} value={bio} style={{height:'auto'}} onChange={handleChange} onKeyUp={handleChange}></textarea>
                                  <label htmlFor="bio">Bio</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='row'>
                          <div className="col-md-12 mb-4">
                            <div className='form-flex form-icon-box'>
                              <div className='form-icon'>
                                <img 
                                  src='/assets/img/icons/mail_icon.svg'
                                  className='form-icon img-fluid'
                                  alt=''
                                />
                              </div>
                              <div className='form-txt'>
                                <div className="form-floating">
                                  <input className={`form-control ${formErrors.email ? 'is-invalid' : ''}`} type="email" id="email" name="email" value={email} onChange={handleChange} onKeyUp={handleChange} />
                                  <label htmlFor="email">Email ID</label>
                                </div>
                              </div>
                            </div> 
                          </div>

                          <div className="col-md-12 mb-4">
                            <div className='form-flex form-icon-box'>
                              <div className='form-icon'>
                                <img 
                                  src='/assets/img/icons/contact_number_icon.svg'
                                  className='form-icon img-fluid'
                                  alt=''
                                />
                              </div>
                              <div className='form-txt'>
                                <div className="form-floating">
                                  <input className={`form-control ${formErrors.number ? 'is-invalid' : ''}`} type="text" id="number" name="number" value={number} onChange={handleChange} onKeyUp={handleChange} />
                                  <label htmlFor="number">Phone Number</label>
                                </div>
                              </div>
                            </div> 
                          </div>
                        </div>

                        <div className="form-button mt-3">
                          <button id="submit" type="submit" className="register-btn">Save</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  );
}

export default CreateCoHost;